<template>
  <div class="border-t py-2.5 gap-x-3 h-full flex flex-col gap-y-4">
    <div class="grid" style="grid-template-columns: 1fr auto">
      <div class="flex flex-col gap-y-3">
        <ul class="flex items-center gap-x-2">
          <strong class="text-lg">{{ state.model?.name }}</strong>
          <c_sex v-if="state.model?.id" :value="state.model?.sex" />
          <text class="text-gray-400 text-xs">
            {{ state.model?.d_conferee_type_name }}
          </text>
          <text>{{ state.model?.pinyin }}</text>
          <div class="flex flex-wrap gap-2">
            <el-tag
              type="info"
              size="small"
              v-for="item in state.model?.d_conferee_tag_json_arr"
              :key="item"
            >
              {{ item }}
            </el-tag>
          </div>
        </ul>
        <c_cell title="证件号" :value="$idCardForamt(state.model?.idcard)" />
        <ul class="grid w-full" style="grid-template-columns: auto auto 50%">
          <c_cell title="联系电话" :value="$phoneFormat(state.model?.phone)" />
          <c_cell title="邮箱" :value="state.model?.email" />
          <c_cell
            title="联系地址"
            class="!items-start"
            :value="state.model?.address"
          />
        </ul>
        <ul class="grid grid-cols-2">
          <c_cell title="单位" :value="state.model?.company" />
          <c_cell title="职务" :value="state.model?.job" />
        </ul>
        <c_cell title="简介" class="!items-start">
          <template #default>
            <div v-html="state.model?.intro"></div>
          </template>
        </c_cell>
      </div>
      <div class="flex items-center pr-10">
        <c_Avatar
          v-if="state.model?.id"
          :file_url="state.model?.avatar_attachment?.file_url"
          :size="20"
          :title="state.model?.name?.slice(0, 1)"
        />
      </div>
    </div>
    <el-table
      :data="state.meeting_list"
      v-loading="!Array.isArray(state.meeting_list)"
      element-loading-background="rgba(0, 0, 0, 0.2)"
    >
      <el-table-column :min-width="260" label="参会记录">
        <template #default="{ row }">
          <c_tabgroup :value2="row.address">
            <template #top>
              <div class="flex items-center gap-x-2">
                <span
                  class="font-bold text-green-700 cursor-pointer hover:underline"
                >
                  <text>{{ row.name }}</text>
                  <text>{{ "[" + row.number + "]" }}</text>
                </span>
                <c_cell title="会议日期" value="2026-05-11 ~ 2026-05-12" />
              </div>
            </template>
          </c_tabgroup>
        </template>
      </el-table-column>
      <el-table-column
        label="参会角色"
        prop="meetingAttendee."
        :width="120"
        :formatter="$tab_TextFormat"
      >
        <template #default="{ row }">
          <c_status
            arrName="Meeting_Attend_Type"
            :value="row.meetingAttendee?.attend_type"
            showBg
            :key="row.meetingAttendee?.attend_type"
          />
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作" fixed="right" align="center" :width="100">
        <template #default="{ row }">
          <el-button
            type="info"
            :icon="Search"
            link
            @click="
              state.selectId = row.id;
              state.showInfo = true;
            "
            >查看
          </el-button>
        </template>
      </el-table-column> -->
    </el-table>
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";
import { conferee_search } from "@/http/conferee";

export default {
  props: {
    id: Number,
  },
  components: {},
  setup(props) {
    const state = reactive({
      model: {},
      nav_index: 0,
    });
    onMounted(() => {
      state.list_data = [];
      if (props.id) {
        conferee_search(props.id).then((res) => {
          if (res.status == 200) {
            const { conferee, meetingList } = res.data?.data || {};
            state.model = conferee;
            state.meeting_list = meetingList;
            if (conferee.avatar_attachment_id) {
              state.model.avatar_attachment_url =
                conferee.avatar_attachment?.file_url;
            }
          }
        });
      }
    });
    return { state };
  },
};
</script>

<style lang="less" scoped></style>
